export function generateObjectId() {
    // 12 bytes will yield 16 base64 characters (since 12 % 3 === 0)
    const randomBytes = new Uint8Array(12);
    crypto.getRandomValues(randomBytes);

    // Convert the byte array to a binary string
    let binary = '';
    for (let i = 0; i < randomBytes.length; i++) {
        binary += String.fromCharCode(randomBytes[i]);
    }

    // Encode the binary string in base64
    return btoa(binary);
}
